import {NgModule} from '@angular/core';
import {RouterModule, Routes} from '@angular/router';
import {LoginComponent} from "./login/login.component";
import {TimelineComponent} from "./timeline/timeline.component";
import {AuthviewComponent} from "./authview/authview.component";
import {AuthGuard} from "./_guards/auth.guard";
import {AdminGuard} from "./_guards/admin.guard";
import {NotfoundComponent} from "./notfound/notfound.component";
import {SettingsComponent} from "./settings/settings.component";
import {MemoryComponent} from "./memory/memory.component";
import {PeopleComponent} from "./people/people.component";
import {ProfileComponent} from "./profile/profile.component";
import {FaqsComponent} from "./trainingCentre/faqs/faqs.component";
import {TermsComponent} from "./terms/terms.component";
import {PrivacyComponent} from "./privacy/privacy.component";
import {TimeoutComponent} from "./timeout/timeout.component";
import {NoAccessComponent} from "./noAccess/noAccess.component";
import {FavouritesComponent} from "./favourites/favourites.component";
import {firstLoginGuard} from "./_guards/first-login.guard";
import {SignupComponent} from "./signup/signup.component";
import {PassthroughComponent} from "./passthrough/passthrough.component";
import {PasswordResetComponent} from "./password-reset/password-reset.component";
import {AcceptInviteComponent} from "./accept-invite/accept-invite.component";
import {DownloadTimelineComponent} from "./download-timeline/download-timeline.component";
import {ResourcesComponent} from "./trainingCentre/resources/resources.component";
import {VideoguidesComponent} from "./trainingCentre/videoguides/videoguides.component";
import {WrittenGuidesComponent} from "./trainingCentre/written-guides/written-guides.component";
import {StatusPageComponent} from "./status-page/status-page.component";
import {HiddenMediaComponent} from "./hidden-media/hidden-media.component";
import {HiddenMediaDetailsComponent} from "./hidden-media/hidden-media-details/hidden-media-details.component";
import {NoboxesComponent} from "./noboxes/noboxes.component";
import {raaNoAccessGuard} from "./_guards/raa-no-access.guard";

const routes: Routes = [
    {path: 'passthrough', component: PassthroughComponent},
    {path: '', redirectTo: 'timeline', pathMatch: 'full'},
    {path: 'login', component: LoginComponent, title: 'VMB - Login'},
    {path: 'password/reset/:token', component: PasswordResetComponent, title: 'VMB - Password Reset'},
    {path: '404', component: NotfoundComponent, title: 'VMB - 404 NOT FOUND'},
    {path: 'noAccess', component: NoAccessComponent, title: 'VMB - Access Denied'},
    {path: 'noBoxes', component: NoboxesComponent, title: 'VMB - Access Denied'},
    {path: 'terms', component: TermsComponent, title: 'VMB - Terms and Conditions'},
    {path: 'invite/:uid/:token', component: AcceptInviteComponent, title: 'VMB - Accept Invite'},
    {path: 'privacy', component: PrivacyComponent, title: 'VMB - Privacy Policy'},
    {path: 'timeout', component: TimeoutComponent, title: 'VMB - Timeout'},
    {path: 'statusPage', component: StatusPageComponent, title: 'VMB - Status'},
    {path: 'signup', component: SignupComponent, title: "VMB - Sign Up", canActivate: [AuthGuard]},
    {
        path: '', component: AuthviewComponent, children: [
            {path: 'timeline', component: TimelineComponent, title: 'VMB - Memory Box'},
            {path: 'timeline/:id', component: TimelineComponent, title: 'VMB - Memory Box'},
            {path: 'settings', component: SettingsComponent, title: 'VMB - Settings'},
            {path: 'favourites', component: FavouritesComponent, title: 'VMB - Favourites'},
            {path: 'favourites/:id', component: FavouritesComponent, title: 'VMB - Favourites'},
            {path: 'hiddenMedias/:timeline', component: HiddenMediaComponent, title: 'VMB - Hidden Media'},
            {path: 'memory/:id', component: MemoryComponent, title: 'VMB - Memory'},
            {path: 'memory/:id/:index', component: MemoryComponent, title: 'VMB - Memory'},
            {path: 'people', component: PeopleComponent, title: 'VMB - People'},
            {path: 'profile/:id', component: ProfileComponent, title: 'VMB - Profile'},
            {path: 'profile/:id/:timelineId', component: ProfileComponent, title: 'VMB - Profile'},
            {path: 'faqs', component: FaqsComponent, title: "VMB - FAQs"},
            {path: 'resources', component: ResourcesComponent, title: "VMB - Resources"},
            {path: 'videoGuides', component: VideoguidesComponent, title: "VMB - Video Guides"},
            {path: 'writtenGuides', component: WrittenGuidesComponent, title: "VMB - Written Guides"},
            {path: 'download/timeline/:uuid', component: DownloadTimelineComponent, title: "VMB - Download Memory Box"},
            {path: 'hiddenMedia/:id', component: HiddenMediaDetailsComponent, title: 'VMB - Hidden Media'},

        ], canActivate: [AuthGuard, firstLoginGuard, raaNoAccessGuard],
    },
    {
        path: '',
        loadChildren: () => import('./admin/admin.module').then(m => m.AdminModule),
        canActivate: [AuthGuard, AdminGuard, firstLoginGuard],
    },

    {path: '**', redirectTo: '404'}
];

@NgModule({
    imports: [RouterModule.forRoot(routes, {
        scrollPositionRestoration: 'enabled'
    })],
    exports: [RouterModule]
})
export class AppRoutingModule {

}
